import * as Phaser from "phaser";
import { atlases } from "$/keys";
import { ApiGlobalPlugin } from "$/game/plugins/ApiGlobalPlugin.ts";
import { CommonVarsGlobalPlugin } from "$/game/plugins/CommonVarsGlobalPlugin.ts";

export class PreloadScene extends Phaser.Scene {
  private api!: ApiGlobalPlugin;
  private global!: CommonVarsGlobalPlugin;

  preload() {
    this.api = this.plugins.get("api") as ApiGlobalPlugin;
    this.global = this.plugins.get("globalVars") as CommonVarsGlobalPlugin;

    this.registry.set("language", this.global.LANG);

    // Load main atlas (contains all sprites including banner)
    this.load.atlas(
      atlases.main.key,
      atlases.main.texture,
      { frames: atlases.main.data.frames },
    );

    this.load.once("complete", async () => {
      await Promise.all([
        this.api.user.authenticate(),
        this.api.pet.get(),
      ]);

      this.scene.start("LoadingScene");
    });
  }
}
